import { Button } from "@/components/ui/button";
import { ReadMore } from "@/components/ui/readMore";
import { PriceResultAllExtra } from "@/lib/type";
import { useMemo, useState } from "react";
import { formatCurrencySymbol } from "@/lib/utils";

interface ExtraItemProps {
  title: string;
  extraId:string
  content: string;
  price: number;
  currency: string;
  isAdd?: boolean;
  onSelect: any;
  itemCount: number;
  MAX_CHARGE_DAYS: Record<string, number>;
  otherExtraProps:PriceResultAllExtra;
  rentalDays: number;

}

const ExtraItem: React.FC<ExtraItemProps> = ({
  title,
  extraId,
  content,
  price,
  currency,
  isAdd = true,
  onSelect,
  itemCount = 0,
  MAX_CHARGE_DAYS,
  otherExtraProps,
}) => {
  const [count, setCount] = useState(itemCount);
  const [add, setAdd] = useState(isAdd);
  const isAddButtonOnly =useMemo(() => {return otherExtraProps.is_insurance || extraId === "NVS"}, [extraId, otherExtraProps.is_insurance ]);

  return (
    <div className={`border-[1px]  bg-white rounded-md p-4 flex flex-col justify-between min-h-64 ${count > 0 ? "border-green-600 shadow-green-600/20 shadow-lg " : "border-neutral-200"}`}>
      <div className="flex flex-row items-center space-x-2 mb-2 min-h-20">
        <img src={`${process.env.ASSETS_URL}/media-library/${extraId}.jpg`}   onError={({ currentTarget }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src="/home/car.png";
        }} className="w-1/5" />
        <p className="font-bold line-clamp-3">{title}</p>
      </div>
      <ReadMore id="read-more-text" text={content} amountOfWords={23} />

      <div className="mt-auto">
      <div className="mt-3 mb-2 align-bottom">
        <p>
          <span className="font-bold text-lg">
            {formatCurrencySymbol(currency)}{`${price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
          </span>{" "}
          / <span className="text-sm">total</span>
        </p>
      </div>
      <div className={`${!isAddButtonOnly&& 'hidden'}`} >
      {add ? (
      <Button
          className="w-full"
          onClick={() => {
            setAdd(!add);
            setCount(1);
            onSelect(1);
          }}
        >
          Add
        </Button>
      ):(
        <Button 
        variant={"outline"}
          className="w-full"
          onClick={() => {
            setAdd(!add);
            setCount(0);
            onSelect(0);
          }}
        >
          Remove
        </Button>
          )} 
      </div>
    
        <div className={`${isAddButtonOnly&& 'hidden'}`} >
        {add ? (
        <Button
          className="w-full"
          onClick={() => {
            let tempCount = count + 1;

            setAdd(!add);
            setCount(tempCount);
            onSelect(tempCount);
          }}
        >
          Add
        </Button>
      ) : (
        <div className="grid grid-cols-3 items-center">
          <Button
            variant={count == 0 ? "disabled" : "outline"}
            onClick={() => {
              if (count > 0) {
                let tempCount = count - 1;
                 if(tempCount == 0){
                  setAdd(!add);
                 }
                setCount(tempCount);
                onSelect(tempCount);
              }
            }}
          >
            -
          </Button>
          <span className="text-center">{count}</span>
          <Button
            variant={"outline"}
            onClick={() => {
              let tempCount = count + 1;

              setCount(tempCount);
              onSelect(tempCount);
            }}
            disabled={count >= MAX_CHARGE_DAYS[extraId.toUpperCase()]}

          >
            +
          </Button>
        </div>
      )}  
        </div>

      </div>
    </div>
  );
};

export default ExtraItem;
